export default __webpack_public_path__ + "static/media/yellowSquareCrownToLeft.571f2e11.svg";